export default function TrustSection() {
  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">

          <div className="flex-1 w-full">
            <div className="rounded-2xl overflow-hidden" style={{ aspectRatio: '1/1', maxWidth: '450px' }}>
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20lifestyle%20photography%20of%20curated%20fashion%20essentials%20on%20light%20oak%20table%2C%20morning%20sunlight%20streaming%20through%20sheer%20curtains%2C%20scandinavian%20editorial%20aesthetic%2C%20soft%20sage%20and%20sand%20tones%2C%20effortless%20everyday%20elegance%2C%20organic%20textures%20linen%20and%20wood&width=900&height=900&seq=trust-product-v2&orientation=squarish"
                alt="Trusted PandabuySpreadsheet shopping guide"
                className="w-full h-full object-cover object-top"
                title="Verified PandabuySpreadsheet Shopping Guide"
              />
            </div>
          </div>

          <div className="flex-1 w-full">
            <span className="inline-block text-xs font-medium text-accent-600 italic mb-4">
              (Verified Shopping Guide)
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight">
              Why Buyers Trust<br />
              <span className="text-foreground-400">PandabuySpreadsheet</span>
            </h2>

            <blockquote className="mt-8 text-base text-foreground-600 leading-relaxed italic border-l-4 border-primary-300 pl-5">
              PandabuySpreadsheet has transformed how I discover fashion finds. Instead of spending hours scrolling through endless listings, I simply browse the curated categories and find exactly what I need — with quality ratings and price comparisons built right in. The weekly updates mean I am always on top of the latest trends without the hassle.
            </blockquote>

            <p className="mt-4 text-sm font-semibold text-foreground-800">
              — pandabuy.bar Team
            </p>

            <div className="flex items-center gap-3 mt-10">
              <button className="w-10 h-10 rounded-full border border-background-300 flex items-center justify-center text-foreground-500 hover:border-foreground-400 transition-colors cursor-pointer" aria-label="Previous review">
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button className="w-10 h-10 rounded-full bg-foreground-950 flex items-center justify-center text-white hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="Next review">
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}